import {
	AppBar,
	Button,
	ClickAwayListener,
	IconButton,
	Toolbar,
} from '@material-ui/core'
import Fade from '@material-ui/core/Fade'
import Popper from '@material-ui/core/Popper'
import { makeStyles } from '@material-ui/core/styles'
import LinkIcon from '@material-ui/icons/Link'
import ListAltIcon from '@material-ui/icons/ListAlt'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import { type MouseEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ChedarLogo from 'src/assets/images/ChedarMainLogo.png'
import CommentButton from 'src/components/sections/Navbar/PublicNavbar/CommentButton'

const useStyles = makeStyles((theme) => ({
	appBar: {
		flexGrow: 1,
		height: '3rem',
		maxHeight: '3rem',
	},
	iconImage: {
		flexGrow: 1,
	},
	logoImage: {
		height: '2.6rem',
	},
	dropDownContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'center',
		width: '11rem',
		backgroundColor: '#ffffff',
		padding: theme.spacing(1),
		marginTop: '0.5rem',
		borderRadius: '0.375rem',
		boxShadow:
			'0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
		border: '1px solid #e2e8f0',
	},
	button: {
		color: theme.palette.primary.main,
		width: '100%',
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
	},
}))

function PublicNavbar() {
	const classes = useStyles()
	const { t } = useTranslation()
	const { t: tPublicPage } = useTranslation('publicPage')
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
	const open = Boolean(anchorEl)
	const id = open ? 'transitions-popper' : undefined

	const handleDropdown = (event: MouseEvent<HTMLElement>) => {
		setAnchorEl(anchorEl ? null : event.currentTarget)
	}

	function handleCopyClick() {
		navigator.clipboard.writeText(window.location.href)
		setAnchorEl(null)
	}

	return (
		<>
			<AppBar position="fixed" className={classes.appBar}>
				<Toolbar variant="dense">
					<div className={classes.iconImage}>
						<img
							src={ChedarLogo}
							alt="Chedar Logo"
							className={classes.logoImage}
						/>
					</div>
					<CommentButton />
					<IconButton
						aria-label="more button"
						aria-controls="button"
						color="inherit"
						onClick={handleDropdown}
					>
						<MoreHorizIcon />
					</IconButton>
				</Toolbar>
			</AppBar>
			<Popper id={id} open={open} anchorEl={anchorEl} transition>
				{({ TransitionProps }) => (
					<Fade {...TransitionProps} timeout={500}>
						<ClickAwayListener
							onClickAway={() => setAnchorEl(null)}
						>
							<div className={classes.dropDownContainer}>
								<Button
									className={classes.button}
									onClick={handleCopyClick}
									startIcon={<LinkIcon />}
								>
									{tPublicPage('navbar.copyLink')}
								</Button>
								<Button
									className={classes.button}
									startIcon={<PictureAsPdfIcon />}
									disabled
								>
									{tPublicPage('navbar.pdfDownload')}
								</Button>
								<Button
									className={classes.button}
									startIcon={<ListAltIcon />}
									disabled
								>
									{tPublicPage('navbar.csvDownload')}
								</Button>
							</div>
						</ClickAwayListener>
					</Fade>
				)}
			</Popper>
		</>
	)
}

export default PublicNavbar
